import { render, staticRenderFns } from "./PasswordRecoveryReset.vue?vue&type=template&id=edbeced0"
import script from "./PasswordRecoveryReset.vue?vue&type=script&lang=ts"
export * from "./PasswordRecoveryReset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports